export default __webpack_public_path__ + "assets/images/7cdbd23d270dfa9d2c5c4b197514607b.jpg";